(function( $ ) {
  $('input[type="submit"]').each(function(){
    let text = $(this).val();
    let button = '<button class="button wpcf7-submit">'+ text +'</button>';
    $(this).after(button);
    $(this).remove();
  });

  // $('.button').each(function() {
  //   let text = $(this).text();
  //   $(this).html('<span>'+ text +'</span>');
  // });

  // pretty checkboxes

  $('input[type="checkbox"]').each(function(){
    $(this).parent().addClass('pretty p-default p-smooth')
    $(this).after('<div class="state"><label></label></div>')
  });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/forms.js